import { cn } from '@/lib/utils';
import { useBranding } from '@/lib/branding';

/** Khối thương hiệu chung (chuẩn "Quản lý thi công"): logo + tên viết tắt của doanh nghiệp (theo Cài đặt). */
export function Brand({ size = 'md', className }: { size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const brand = useBranding();
  const mark = size === 'sm' ? 'size-[30px]' : size === 'lg' ? 'size-12' : 'size-[37px]';
  const text = size === 'sm' ? 'text-[20px]' : size === 'lg' ? 'text-[26px]' : 'text-[21px]';
  return (
    <span className={cn('flex items-center gap-[11px] text-ink', className)}>
      <img src={brand.logoUrl} alt="" className={cn('shrink-0 object-contain', mark)} />
      <span className={cn('font-extrabold leading-none tracking-[-0.8px]', text)}>{brand.title}</span>
    </span>
  );
}
